import Insert_box from './insert_box';


export default Insert_box;

export {
    Insert_box
}